import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useAppContext } from '../../appProvider/contextProvider';
import NotificationPreview from '../../components/NotificationPreview/NotificationPreview';
import { ERRORS, URL_VALIDATOR } from '../../constants/AppConstants';
import getCroppedImage from '../../Util/getCroppedImage';
import Select from 'react-select'
import styled from 'styled-components';
import IconCropper from '../../components/IconCropper/iconCropper';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { getCommonSegments, getSegments } from '../../services/segmentService';
import { getTopics, getCommonTopics } from '../../services/topicsService';
import timezones from 'timezones-list';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { createCampaigns, createCampaignsWithMultiWebsites, getCampaignById } from '../../services/campaignService';
import MultiValueDropdown from '../../components/DropDown/MultiValueDropdown';
import PremiumLock from '../../components/PremiumFeatures/PremiumLock';
import HelperComponent from '../../components/HelperComponent/HelperComponent';


const StyledSelect = styled(Select)`
    .css-1s2u09g-control{
        min-width: ${({width}) => width || '18rem' };
        max-width: ${({width}) => width || '18rem' };
    }
    .css-1pahdxg-control{
        min-width: ${({width}) => width || '18rem' };
        max-width: ${({width}) => width || '18rem' };
        z-index:9;
    }
    .css-2613qy-menu{
        min-width: ${({width}) => width || '18rem' };
        max-width: ${({width}) => width || '18rem' };
    }
`

const CreateCampaigns = () => {

    const history = useHistory();

    const { state } = useLocation();
    

    const bannerRef = useRef(null);
    const iconRef = useRef(null);

    const {
        selectedWebsite = {},
        userDetails,
        isDirty,
        setIsDirty,
        setDiscardPromptOpen,
        isFeatureAvailable,
        websites = []
    } = useAppContext();
    
    const [is_cta_enabled, setCTAEnabled] = useState(false);
    const [isCTA2Enabled, setCTA2Enabled] = useState(false);

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);

    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(null);
    const [messageLengthError, setMessageLengthError] = useState(null);

    const [landing_url, setWelcomeLink] = useState('');
    const [welcomeLinkError, setWelcomeLinkError] = useState(null);

    const [tag, setTag] = useState('');

    const [iconPath, setIconPath] = useState('');
    const [iconName, setIconName]= useState('');
    const [openCropper, setOpenCropper] = useState(false);
    const [icon, setIcon] = useState(null);

    const [bannerPath, setBannerPath] = useState('');
    const [bannerName, setBannerName]= useState('');
    const [openBannerCropper, setOpenBannerCropper] = useState(false);
    const [banner, setBanner] = useState(null);


    const [ttl, setTTL] = useState(3);
    const [ttlType, setTTLType] = useState('day')
    const [ttlError, setTTLError] = useState(null);


    const [cta1Title, setCta1Title] = useState('');
    const [cta1TitleError, setCTA1TitleError] = useState(null);
    const [cta1URL, setCta1URL] = useState('');
    const [cta1URLError, setCTA1URLError] = useState(null);


    const [cta2Title, setCta2Title] = useState('');
    const [cta2TitleError, setCTA2TitleError] = useState(null);
    const [cta2URL, setCta2URL] = useState('');
    const [cta2URLError, setCTA2URLError] = useState(null);


    const [enableForTestDevice, setEnableForTestDevice] = useState(false);
    

    const [schedulingType, setSchedulingType] = useState('IMMED');
    const [timezone, setTimezone] = useState('');

    const [schedulingDate, setSchedulingDate] = useState(null);
    const [schedulingTime, setSchedulingTime] = useState(null);
    const [schedulingTimeError, setSchedulingTimeError] = useState(null);
    const [timeInterval, setTimeInterval] = useState(null);

    const [segments, setSegments] = useState([]);
    const [selectedSegments, setSelectedSegments] = useState();
    
    const [topics, setTopics] = useState([]);
    const [selectedTopics, setSelectedTopics] = useState([]);

    const [isFilterOpen , setIsFilterOpen] = useState(false);

    const [ valueString, setValueString ] = useState('');

    const [websiteOptions, setWebsiteOptions] = useState([]);
    const [selectedWebsites, setSelectedWebsites] = useState([]);

    const [showWebsiteSelection, setShowWebsiteSelection] = useState(false);

    const [gpmSubscriber, setGpmSubscriber] = useState(false);

    useEffect(() => {
        const discard = () => {
            reset();
        }
        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [])

    useEffect(() => {
        if(selectedWebsite) {
            setSelectedWebsites([{value: selectedWebsite.id, label: selectedWebsite.url, isFixed: true}]);
        }
    }, [selectedWebsite]);

    useEffect(() => {
        if(userDetails) {
            setTimezone(userDetails.timezone);
            setSchedulingDate(momentTz().tz(userDetails.timezone).format('YYYY-MM-DD'));
            setWebsites();
            // setSchedulingTime(momentTz().tz(userDetails.timezone).add(10, 'minute').format('HH:mm'));
        }
    }, [userDetails, websites]);

    // styles that do not show 'x' for fixed options
  const styles = useMemo(
    () => ({
      multiValueRemove: (base, state) => {
        return state.data.isFixed ? { ...base, display: 'none' } : base;
      },
    }),
    []
  );

  // to not allow website selector to remove default website
  const handleChange = useCallback(
    (inputValue, { action, removedValue }) => {
      switch (action) {
        case 'remove-value': // delete with 'x'
        case 'pop-value': // delete with backspace
          if (removedValue.isFixed) {
            setSelectedWebsites([...selectedWebsites, removedValue]);
            return;
          }
          break;
        case 'clear': // clear button is clicked
            setSelectedWebsites(selectedWebsites.filter((v) => v.isFixed));
          return;
        default:
      }
      console.log(inputValue);
      setSelectedWebsites(inputValue);
      setIsDirty(true);
    if(!isMulti(inputValue)) {
        setCommonSegments.mutate();
        setCommonTopics.mutate();
    } else {
        refetchSegments();
        refetchTopics();
    }
    },
    [selectedWebsites]
  );


    const setWebsites = () => {
        const webSites = websites.map(({id, url}) => ({value: id, label: url}));
        setWebsiteOptions(webSites); 
    }

    const {refetch: refetchSegments} = useQuery(['fetchSegments', selectedWebsite?.id], () => getSegments(selectedWebsite?.id), {
            enabled: !!selectedWebsite,
            onSuccess: (segments) => {
                if(segments.errors) {
                    setSegments([{ value: 0, label: 'All Subscribers'}]);
                    setSelectedSegments({ value: 0, label: 'All Subscribers'});
                } else {
                    const segmentsArray = segments.map(({id, name}) =>({ value: id, label: name}));
                    segmentsArray.unshift({ value: 0, label: 'All Subscribers'}  );
                    setSelectedSegments({ value: 0, label: 'All Subscribers'});
                    setSegments(segmentsArray);
                }
            }
    });

    const {refetch: refetchTopics} =useQuery(['fetchTopics', selectedWebsite?.id],  () => getTopics(selectedWebsite?.id) , {
        enabled: !!selectedWebsite,
        onSuccess: (topics) => {
            if(topics.errors) {

            } else {
                const topicsArray = topics.map(({id, name}) => {
                    return { value: id, label: name}  
                });
                setTopics(topicsArray);
            }
        }
    });

    useQuery(['fetchCampaign', {webId: selectedWebsite?.id, id: state?.id}], 
        () => getCampaignById({webId: selectedWebsite?.id, id: state?.id}),
        {
            enabled: !!selectedWebsite && !!state?.id,
            onSuccess: (campaign) => {
                if(campaign.errors) {

                } else {
                    setCampaignDetails(campaign);
                    toast.info('Note: Please reset Banner Image and Icon in case of copy campaign.');
                }
                
            }
        }
        
    );


    const setCampaignDetails = (campaign) => {
        setTitle(`${campaign?.title}_copy`);
        setMessage(campaign?.message);
        setWelcomeLink(campaign?.landing_url);
        setEnableForTestDevice(campaign?.is_test);
        setCTAEnabled(campaign?.is_cta_enabled);
        if(campaign?.is_cta_enabled) {
            setCta1Title(campaign?.button);
            setCta1URL(campaign?.url);
            if(campaign?.addl_button && campaign?.addl_url) {
                setCTA2Enabled(true);
                setCta2Title(campaign?.addl_button);
                setCta2URL(campaign?.addl_url)
            }
        }
        setSelectedSegments(campaign?.segments);
        setSelectedTopics(campaign?.topic);
        setTag(campaign?.tag);
    } 

    const setCommonSegments = useMutation(() => {
        return getCommonSegments();
    }, {
        onSuccess: (segments) => {
            if(segments.errors) {
                setSegments([{ value: 0, label: 'All Subscribers'}]);
                setSelectedSegments({ value: 0, label: 'All Subscribers'});
            } else {
                const segmentsArray = segments.map(({id, name}) =>({ value: id, label: name}));
                segmentsArray.unshift({ value: 0, label: 'All Subscribers'}  );
                setSelectedSegments({ value: 0, label: 'All Subscribers'});
                setSegments(segmentsArray);
            }
        }
    });

    const setCommonTopics = useMutation(() => {
        return getCommonTopics();
    }, {
        onSuccess: (topics) => {
            if(topics.errors) {

            } else {
                const topicsArray = topics.map(({id, name}) => {
                    return { value: id, label: name}  
                });
                setTopics(topicsArray);
            }
        }
    });

    const handelTitleChange = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.TITLE_REQUIRED);
        } else {
            setTitleError(null);
        }

        if(value.trim().length <= 100) {
            setTitle(value);
        }
    }

    const handelMessageChange = (value) => {
        setIsDirty(true);
        if(value.trim().length > 120 ) {
            setMessageLengthError(ERRORS.WEBSITE_MESSAGE_MAX_LENGTH);
        }
        else {
            setMessageError(null);
            setMessageLengthError(null);
        }
        if(value.trim().length <= 300) {
            setMessage(value);
        }
    }

    const handelWelcomeLinkChange = (value) => {
        setIsDirty(true);
        
        if(value.trim().length <=0 ) {
            setWelcomeLinkError(ERRORS.WEBSITE_URL_REQUIRED);
        }else if(!value.match(URL_VALIDATOR)) {
            setWelcomeLinkError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setWelcomeLinkError(null);
        }
        if(value.trim().length <= 150) {
            setWelcomeLink(value);
        }
    }

    const handelIconUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setIsDirty(true);
            setIconName(target.files[0].name);
            setIconPath(url);
            setOpenCropper(true);
            iconRef.current.value = '';
        }
    });


    const onCancelIconCrop = () => {
        setIconName('');
        setIconPath(iconPath);
        setOpenCropper(false);
    }
    
    const getCroppedIcon = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            iconPath,
            croppedAreaPixel,
            0,
            iconName,
        );
        setIconPath(url);
        setIcon(file);
        setOpenCropper(false);
    }

    const handelBannerUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setIsDirty(true);
            setBannerName(target.files[0].name);
            setBannerPath(url);
            setOpenBannerCropper(true);
            bannerRef.current.value = '';
        }
    });

    const onCancelBannerCrop = () => {
        setBannerName('');
        setBannerPath(iconPath);
        setOpenBannerCropper(false);
    }
    
    const getCroppedBanner = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            bannerPath,
            croppedAreaPixel,
            0,
            bannerName,
        );
        setBannerPath(url);
        setBanner(file);
        setOpenBannerCropper(false);
    }

    const handelTtlChange = (value) => {
        setTTL(value);
        setIsDirty(true);
        if(value < 1) {
            setTTLError(`Expiration time cannot be less than 1 ${ttlType}`);
        } else {
            setTTLError(null);
        }
    }

    const handelCTA1TitleChange = (value) => {   
        setIsDirty(true);     
        if(value.trim().length <=0 ) {
            setCTA1TitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setCTA1TitleError(null);
        }
        if(value.trim().length <= 20) {
            setCta1Title(value);
        }
    }

    const handelCTA1URLChange = (value) => {
        setIsDirty(true);
        
        if(value.trim().length <=0 ) {
            setCTA1URLError(ERRORS.WEBSITE_URL_REQUIRED);
        }  else if(!value.match(URL_VALIDATOR)) {
            setCTA1URLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setCTA1URLError(null);
        }
        if(value.trim().length <= 150) {
            setCta1URL(value);
        }
        
    }

    const handelCTA2TitleChange = (value) => {
        setIsDirty(true);
        
        if(value.trim().length <=0 ) {
            setCTA2TitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setCTA2TitleError(null);
        }
        if(value.trim().length <= 20) {
            setCta2Title(value);
        }
    }

    const handelCTA2URLChange = (value) => {
        setIsDirty(true);
        
        if(value.trim().length <=0 ) {
            setCTA2URLError(ERRORS.WEBSITE_URL_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setCTA2URLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setCTA2URLError(null);
        }
        if(value.trim().length <= 150) {
            setCta2URL(value);
        }

    }

    const deleteCta1 = () => {
        setCTAEnabled(!is_cta_enabled);
        setCta1Title('');
        setCta1URL('');
        setCTA1TitleError(null);
        setCTA1URLError(null);
        deleteCta2();
    }

    const deleteCta2 = () => {
        setCTA2Enabled(false);
        setCta2Title('');
        setCta2URL('');
        setCTA2TitleError(null);
        setCTA2URLError(null);
    }

    const reset = () => {
        setTitle('');
        setMessage('');
        setWelcomeLink('');
        setCta1Title('');
        setCta1URL('');
        setCta2Title('');
        setCta2URL('');
        setSchedulingType('IMMED');
        setSelectedTopics([]);
        setSelectedSegments({ value: 0, label: 'All Subscribers'});
        setEnableForTestDevice(false);
        setTTL(3);
        setIcon(null);
        setIconName('');
        setIconPath('');
        setBanner(null);
        setBannerName('');
        setBannerPath('');
        setCTA2Enabled(false);
        setCTAEnabled(false);
        setTag('');

        setValueString('')


        setTitleError(null);
        setMessageError(null);
        setWelcomeLinkError(null);
        setCTA1TitleError(null);
        setCTA1URLError(null);
        setCTA2TitleError(null);
        setCTA2URLError(null);
        setSchedulingTimeError(null);
        setTTLError(null);
        setMessageLengthError(null);
        setIsDirty(false);
        clearInterval(timeInterval);
        setTimeInterval(null);
        setSelectedWebsites([{value: selectedWebsite?.id, label: selectedWebsite?.url}]);
    }

    const discard = () => {

        setDiscardPromptOpen(true);
    }

    const onClearBanner = () => {
        setBanner(null);
        setBannerPath('');
        setBannerName('');
    }
    
    const onClearIcon = () => {
        setIcon(null);
        setIconPath('');
        setIconName('');
    }

    const getMinDate = () => {
        return momentTz().tz(timezone).format('YYYY-MM-DD');
    }

    const getMinTime = () => {
        return momentTz().tz(timezone).add(10, 'minute').format('HH:mm');
    }

    const changeDate = (value) => {
        setIsDirty(true);
        clearInterval(timeInterval);
        const selectedDate = moment(`${schedulingDate} ${value}`).format('YYYY-MM-DD HH:mm');
        setSchedulingDate(moment(value).format('YYYY-MM-DD'));
        const timeIntervals = setInterval(() => {
        const currentDate = moment((momentTz().tz(timezone).add(10, 'minute'))).format('YYYY-MM-DD HH:mm');
            if(new Date(selectedDate) < new Date(currentDate)) {
                setSchedulingTimeError(ERRORS.OLD_TIME);
            } else {
                setSchedulingTimeError(null);
            }
        }, 60000)
        setTimeInterval(timeIntervals);
        
    }

    const changeTime = (value) => {
        setIsDirty(true);
        clearInterval(timeInterval);
        const selectedDate = moment(`${schedulingDate} ${value}`).format('YYYY-MM-DD HH:mm');
        setSchedulingTime(value);
        const currentDate = moment((momentTz().tz(timezone).add(10, 'minute'))).format('YYYY-MM-DD HH:mm');
            if(new Date(selectedDate) < new Date(currentDate)) {
                setSchedulingTimeError(ERRORS.OLD_TIME);
            }else {
                setSchedulingTimeError(null);
            }
        const timeIntervals = setInterval(() => {
            const currentDate = moment((momentTz().tz(timezone).add(10, 'minute'))).format('YYYY-MM-DD HH:mm');
            if(new Date(selectedDate) < new Date(currentDate)) {
                setSchedulingTimeError(ERRORS.OLD_TIME);
            }else {
                setSchedulingTimeError(null);
            }
        }, 60000);
        setTimeInterval(timeIntervals);
    }

    const changeTimeZone = ({value}) => {
        setIsDirty(true);
        clearInterval(timeInterval);
        const selectedDate = moment(`${schedulingDate} ${value}`).format('YYYY-MM-DD HH:mm');
        setTimezone(value);
        const timeIntervals = setInterval(() => {
            const currentDate = moment((momentTz().tz(timezone).add(10, 'minute'))).format('YYYY-MM-DD HH:mm');
            if(new Date(selectedDate) < new Date(currentDate)) {
                setSchedulingTimeError(ERRORS.OLD_TIME);
            } else {
                setSchedulingTimeError(null);
            }}, 60000);
        setTimeInterval(timeIntervals);
    }

    const changeSchedulingType = (value) => {
        setIsDirty(true);
        setSchedulingType(value);
        setSchedulingTimeError(null);
        setSchedulingTime(null);
        clearInterval(timeInterval);
        setTimeInterval(null);
    }

    const onChangeSegments = (value) => {
        setIsDirty(true);
        setSelectedSegments(value);
    }
    
    const onChangeTopics = (value) => {
        setIsDirty(true);
        setSelectedTopics(value);
        getValueSelected(value);
    }

    const isSaveDisabled = () => {
        return title.length <= 0  || titleError || messageError || landing_url.length <= 0 || welcomeLinkError || ttl < 1 || ttlError ||
        (selectedWebsites  && selectedWebsites.length <= 0) ||
        (is_cta_enabled && ( cta1Title.length <= 0 || cta1URL.length <= 0 || cta1TitleError || cta1URLError)) ||
        (isCTA2Enabled && ( cta2Title.length <= 0 || cta2URL.length <= 0 || cta1TitleError || cta1URLError )) ||
        ( ((schedulingType !== 'IMMED') && (schedulingTime === null)) || ((schedulingType === 'SCHED') && schedulingTimeError)); 
    }
    
    const createCampaign = useMutation((formData) => {
        return createCampaigns(selectedWebsite?.id, formData)}, {
            onSuccess: ((campaign) => {
                if(campaign.errors) {

                } else {
                    reset();
                    toast.success('Campaign Created Successfully');
                    if(campaign.type === 'IMMED') {
                        history.push('/campaign-report');
                    } else {
                        history.push('/schedule-campaign');
                    }
                }
            }),
            onError: ((error) => {
                console.log(error);
                // toast.error(error.message);
            })
    });

    const createCampaignMultiWebsite = useMutation((formData) => {
        return createCampaignsWithMultiWebsites(formData)}, {
            onSuccess: ((campaign) => {
                if(campaign.errors) {

                } else {
                    reset();
                    toast.success('Campaign Created Successfully');
                    history.push('/campaign-report');
                }
            }),
            onError: ((error) => {
                console.log(error);
                // toast.error(error.message);
            })
    });

    const isMulti = (value) => {
        return value?.length === 1 && value[0]?.value === selectedWebsite?.id;
    };

    const saveCampaign = (event) => {
        event.preventDefault();
        if(!isMulti(selectedWebsites)) {
            saveMulti();
        } else {
            save();
        }
    }

    const saveMulti = () => {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('message', message);
        formData.append('is_cta_enabled', is_cta_enabled);
        formData.append('landing_url', landing_url);
        if(is_cta_enabled) {
            formData.append('button', cta1Title);
            formData.append('url', cta1URL);
            if(isCTA2Enabled) {
                formData.append('addl_button', cta2Title);
                formData.append('addl_url', cta2URL);
            } else {
                formData.append('addl_button', '');
                formData.append('addl_url', '');
            }
        } else {
            formData.append('button', '');
            formData.append('url', '');
            formData.append('addl_button', '');
            formData.append('addl_url', '');
        }
        if(banner) {
            formData.append('banner_image', banner);
        } else if(!banner && !bannerPath) {
            formData.append('banner_image', '');
        }
        if(icon) {
            formData.append('icon', icon);
        }else if(!icon && !iconPath) {
            formData.append('icon', '');
        }
        if(ttlType === 'day') {
            formData.append('time_to_live', ttl * 24 * 60 * 60);
        }
        if(ttlType === 'hour') {
            formData.append('time_to_live', ttl * 60 * 60);
        }
        formData.append('is_test', enableForTestDevice);
        formData.append('type', schedulingType);
        if(schedulingType !== 'IMMED') {
            formData.append('scheduled_at',
                moment(`${schedulingDate} ${schedulingTime}`)
                .format('YYYY-MM-DDTHH:mm:ss.SSSZ'));
        }
        if(schedulingType === 'SCHED') {
            formData.append('scheduled_tz', timezone);
        }
        if(selectedWebsites && selectedWebsites.length > 0) {
            const websiteIds = selectedWebsites.map(({value}) => value);
            formData.append('websites', websiteIds);
        }
        if(tag && tag.length >  0) {
            formData.append('tag', tag);
        }
        if(selectedSegments && selectedSegments.value !== 0) {
            formData.append('segment', selectedSegments.value);
        }
        if(selectedTopics && selectedTopics.length > 0) {
            const topicIds = selectedTopics.map(({value}) => Number(value));
            formData.append('topics', topicIds);
        }
        if(selectedWebsite && selectedWebsite?.is_migrated_from_gpm ) {
            formData.append('can_send_to_gpm', gpmSubscriber);
        }
        createCampaignMultiWebsite.mutate(formData);
    }

    const save = () => {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('message', message);
        formData.append('is_cta_enabled', is_cta_enabled);
        formData.append('landing_url', landing_url);
        if(is_cta_enabled) {
            formData.append('button', cta1Title);
            formData.append('url', cta1URL);
            if(isCTA2Enabled) {
                formData.append('addl_button', cta2Title);
                formData.append('addl_url', cta2URL);
            } else {
                formData.append('addl_button', '');
                formData.append('addl_url', '');
            }
        } else {
            formData.append('button', '');
            formData.append('url', '');
            formData.append('addl_button', '');
            formData.append('addl_url', '');
        }
        if(banner) {
            formData.append('banner_image', banner);
        } else if(!banner && !bannerPath) {
            formData.append('banner_image', '');
        }
        if(icon) {
            formData.append('icon', icon);
        }else if(!icon && !iconPath) {
            formData.append('icon', '');
        }
        if(ttlType === 'day') {
            formData.append('time_to_live', ttl * 24 * 60 * 60);
        }
        if(ttlType === 'hour') {
            formData.append('time_to_live', ttl * 60 * 60);
        }
        // formData.append('time_to_live', ttl);
        formData.append('is_test', enableForTestDevice);
        formData.append('type', schedulingType);
        if(schedulingType !== 'IMMED') {
            formData.append('scheduled_at',
                moment(`${schedulingDate} ${schedulingTime}`)
                .format('YYYY-MM-DDTHH:mm:ss.SSSZ'));
        }
        if(schedulingType === 'SCHED') {
            formData.append('scheduled_tz', timezone);
        }
        if(selectedSegments && selectedSegments?.value !== 0) {
            formData.append('segment', selectedSegments.value);
        }
        if(selectedTopics && selectedTopics?.length > 0) {
            const topicIds = selectedTopics.map(({value}) => Number(value));
            formData.append('topics', topicIds);
        }
        if(tag && tag?.length >  0) {
            formData.append('tag', tag);
        }
        if(selectedWebsite && selectedWebsite?.is_migrated_from_gpm ) {
            formData.append('can_send_to_gpm', gpmSubscriber);
        }
        createCampaign.mutate(formData);
    }

    const getTimeZones = () => {
        return  timezones.map(({name, tzCode}) => ({value: tzCode, label: name}));
    }

    const getTimeZone = () => {
        return  timezones.map(({name, tzCode}) => ({value: tzCode, label: name})).find(({value}) => value === timezone) ;
    }

    const getValueSelected = (values) => {
        const valueStr = values.length > 1 ? `${values[0].label} & ${values.length - 1} more` : values[0].label;
        setValueString(valueStr || '');
    }

    const canSendToGPM = () => {
        const migratedSelectedWebsites = selectedWebsites.map(({value}) => {
            const website = websites.find(({id}) => id === value);
            return !!website && !!website.is_migrated_from_gpm;
        });
        return migratedSelectedWebsites.every(val => val);
    }

    const onSelectAllWebsite = () => {
        if(!showWebsiteSelection) {
            const webSites = websites.map(({id, url}) => {
                if(id === selectedWebsite?.id) {
                    return {value: id, label: url, isFixed: true}
                } 
                return {value: id, label: url}
            });
            console.log(webSites);
            setSelectedWebsites(webSites);
            setShowWebsiteSelection(true);
        } else {
            console.log(selectedWebsites);
            setShowWebsiteSelection(false);
        }
        
    }
 
    const onCopyLandingURL = (cta) => {
        if(cta === 'cta1') {
            handelCTA1URLChange(landing_url || '');
        }
        if(cta === 'cta2') {
            handelCTA2URLChange(landing_url || '');
        }
    }

    return <> 
        <div className='panel full-height'>
            <div className='panel-header'>
                <div className='d-flex flex-wrap justify-content-between align-items-center'>
                            <div>
                                <h3 className='mb-0'>
                                    Create Campaign
                                    <HelperComponent
                                        component={'Create Campaign'} 
                                        href='https://chirpyweb.com/documentation_posts/create-campaign/' />    
                                </h3>
                            </div>
                            <div className='d-flex justify-content-between ' style={{gap: '10px'}}>
                                <button className='btn btn-sm btn-danger' disabled={!isDirty} onClick={() => discard()} >Discard</button>
                                <button className='btn btn-sm btn-primary' onClick={saveCampaign}  disabled = {isSaveDisabled()} >Send</button>                                         
                            </div> 
                        </div>                                
            </div>
            <div className='panel-body d-flex flex-column scrollable_y'>
            <div className='row'>
                <div className='col'>
                    <div className='panel panel-bordered mb-3'>
                        <div className='panel-header'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h5 className='medium mb-0'>Campaign Content</h5>
                            </div>                                
                        </div>
                        <div className='panel-body'>
                            <div className='form-group'>
                                <div className='d-flex justify-content-between'>
                                    <label className='form-label text-dark medium'>Title *</label>
                                    <div>{title.length} / 100</div>
                                </div>
                                <div className='input-addon input-group-right'>
                                    <i className='icon icon-edit'></i>
                                    <input 
                                        type='text' 
                                        className='form-control' 
                                        value={title}
                                        onChange={({target}) => handelTitleChange(target.value)}
                                        maxLength={100} 
                                    />                        
                                </div>
                                <span>Note: The Campaign title will be displayed to the user. </span>
                                { titleError && <div><span className='error-message'>{titleError}</span></div>}
                            </div>
                            <div className='form-group'>
                                <div className='d-flex justify-content-between'>
                                    <label className='form-label text-dark medium'>Message</label>
                                    <div>{message.length} / 300</div>
                                </div>
                                <div className='input-addon input-group-right'>
                                    <textarea 
                                        type='text' 
                                        rows='3' 
                                        className='form-control'
                                        value={message}
                                        onChange={({target}) => handelMessageChange(target.value)}    
                                        maxLength={300}
                                    ></textarea>                        
                                </div>
                                { messageError && <div><span className='error-message'>{messageError}</span></div>}
                                { messageLengthError && <div><span className='error-message'>{messageLengthError}</span></div>}
                                
                                <span>Note: The welcome message is displayed to the user.</span>
                            </div>
                            <div className='form-group'>
                                <div className='d-flex justify-content-between'>
                                    <label className='form-label text-dark medium'>Landing Page Url *</label>
                                    <div>{landing_url.length} / 150</div>
                                </div>
                                <div className='input-addon input-group-right'>
                                    <i className='icon icon-website'></i>
                                    <input 
                                        type='text' 
                                        className='form-control'
                                        value={landing_url}
                                        onChange={({target}) => handelWelcomeLinkChange(target.value)}
                                        maxLength={150}
                                    />                        
                                </div> 
                                <span >
                                    Note: After clicking the push notification, the subscribers will see the complete URL of the web pages they visited. For instance, https://blog.chirpyweb.com
                                </span>
                                { welcomeLinkError && <div><span className='error-message'>{welcomeLinkError}</span></div>}
                            </div>
                            <div className='form-group'>
                                <label className='medium'>Banner Image</label>
                                <div className='d-flex'>                                                        
                                    <div className='form-group mb-0'> 
                                        <div className='d-flex align-items-center'>
                                        <div className='file-upload'>                                            
                                            <input 
                                                type='file' 
                                                accept='image/*'
                                                onChange={(event) => handelBannerUpload(event)}
                                                ref={bannerRef}   
                                            />
                                            <i className='icon icon-file'></i>                                            
                                            Select File
                                        </div>
                                        {bannerName && <span className='mx-2 image-name'>{bannerName}</span>}     
                                        </div>
                                    </div>
                                    {bannerName && <button className='btn ml-2 btn-grey' onClick={() => onClearBanner()} ><i className='icon icon-close mr-2'></i>Clear</button>}
                                </div> 
                                <span>Note: The image will appear inside the push notification received by your readers on chrome on windows, Recommended size 360X240 (2:1 Aspect Ratio).</span>                                                   
                            </div>
                            <div className='form-group'>
                                <label className='medium'>Icon</label>
                                <div className='d-flex'>                                                        
                                    <div className='form-group mb-0'>                                                            
                                        <div className='d-flex align-items-center'>
                                            <div className='file-upload'>
                                                <input 
                                                    type='file'
                                                    accept='image/*'
                                                    onChange={(event) => handelIconUpload(event)}
                                                    ref={iconRef}  
                                                />
                                                <i className='icon icon-file'></i>                                            
                                                Select File
                                            </div>
                                            {iconName && <span className='mx-2 image-name'>{iconName}</span>}  
                                        </div>
                                    </div>
                                    {iconName && <button className='btn ml-2 btn-grey' onClick={() => onClearIcon()}><i className='icon icon-close mr-2'></i>Clear</button>}
                                </div> 
                                <span>Note: This image will be used as an icon only for this push notification.</span>                                                   
                            </div>
                        </div>
                    </div>
                    <div className='panel panel-bordered mb-3'>
                        <div className='panel-body'>
                            <div className='form-row  align-items-center'>
                                <div className='col-lg-4'>
                                    <h6 className='mb-0 medium mr-3'>Set notification to expire in</h6>
                                </div>
                                <div className='form-group mb-0 col-lg-3'>
                                    <input 
                                        type='number' 
                                        className='form-control' 
                                        value={ttl}
                                        onChange={({target}) => handelTtlChange(target.value)} 
                                        min={1}   
                                    />
                                { ttlError && <div><span className='error-message'>{ttlError}</span></div>}
                                </div>
                                <div className='form-group col-md-3 mb-0'>
                                    <select 
                                        value={ttlType} 
                                        onChange={({target}) => setTTLType(target.value)} 
                                        className='form-control'
                                    >
                                        <option value='hour' >Hour(s)</option>
                                        <option value='day' >Day(s)</option>
                                    </select>
                                </div>
                            </div>                                            
                        </div>
                    </div>
                    <div className='panel panel-bordered mb-3'>
                        <div className='panel-header m-1 d-flex'>
                            <h6 className='mb-0 medium mr-3'>CTA’s </h6>
                            <label className='toggle-control toggle-control-sm mb-2'>
                                <input type='checkbox' checked={is_cta_enabled} onChange={() => deleteCta1()} />
                                <span className='control'></span>
                            </label>
                        </div>
                        <div className='panel-body' style={{display : is_cta_enabled ? 'block' : 'none'}}>
                        <>
                                <h6 className='medium'>Button 1</h6>
                                <hr className='my-3'/>
                                <div className='form-row'>
                                    <div className='form-group col-12 col-md-6 col-xl-4'>   
                                        <div className='d-flex justify-content-between'>
                                            <label className='form-label text-dark medium'>Title *</label>
                                            <div>{cta1Title.length} / 20</div>
                                        </div>           
                                        <div className=''>
                                            <input 
                                                type='text' 
                                                placeholder='Eg. Read More' 
                                                className='form-control'
                                                value={cta1Title}
                                                onChange={({target}) => handelCTA1TitleChange(target.value)}  
                                                maxLength={20}  
                                            />                        
                                        </div> 
                                        { cta1TitleError && <div><span className='error-message'>{cta1TitleError}</span></div>} 
                                    </div>
                                    <div className='form-group col-12 col-md-6 col-xl-6'>  
                                        <div className='d-flex justify-content-between'>
                                            <label className='form-label text-dark medium'>Landing URL *
                                            &nbsp;&nbsp;<span className="primary-link terms-link" onClick={() => onCopyLandingURL('cta1')}>(Copy from Landing Page URL)</span>
                                            </label>
                                            <div>{cta1URL.length} / 150</div>
                                        </div>
                                        <div className='input-addon input-group-right'>
                                            <input 
                                                type='text' 
                                                placeholder='e.g. https://mayonlinestore.com/cart' 
                                                className='form-control'
                                                value={cta1URL}
                                                onChange={({target}) => handelCTA1URLChange(target.value)}
                                                maxLength={150}      
                                            />                        
                                        </div>
                                        { cta1URLError && <div><span className='error-message'>{cta1URLError}</span></div>}   
                                    </div>
                                </div> 
                            </>
                            { isCTA2Enabled && <>
                                <h6 className='medium'>Button 2</h6>
                                <hr className='my-3'/>
                                <div className='form-row'>
                                    <div className='form-group col-12 col-md-6 col-xl-4'>   
                                        <div className='d-flex justify-content-between'>
                                            <label className='form-label text-dark medium'>Title *</label>
                                            <div>{cta2Title.length} / 20</div>
                                        </div>          
                                        <div className=''>
                                            <input 
                                                type='text' 
                                                placeholder='Eg. Read More' 
                                                className='form-control'
                                                value={cta2Title}
                                                onChange={({target}) => handelCTA2TitleChange(target.value)}
                                                maxLength={20}    
                                                />                        
                                        </div>  
                                        { cta2TitleError && <div><span className='error-message'>{cta2TitleError}</span></div>} 
                                    </div>
                                    <div className='form-group col-12 col-md-6 col-xl-6'>  
                                        <div className='d-flex justify-content-between'>
                                            <label className='form-label text-dark medium'>Landing URL *
                                            &nbsp;&nbsp;<span className="primary-link terms-link" onClick={() => onCopyLandingURL('cta2')}>(Copy from Landing Page URL)</span>
                                            </label>
                                            <div>{cta2URL.length} / 150</div>
                                        </div>
                                        <div className='input-addon input-group-right'>
                                            <input 
                                                type='text' 
                                                placeholder='e.g. https://mayonlinestore.com/cart' 
                                                className='form-control'
                                                value={cta2URL}
                                                onChange={({target}) => handelCTA2URLChange(target.value)} 
                                                maxLength={150}
                                            />                        
                                        </div>
                                        { cta2URLError && <div><span className='error-message'>{cta2URLError}</span></div>}   
                                    </div>
                                </div> 
                            </>}
                            
                            { !isCTA2Enabled && <button className='btn btn-outline' onClick ={() => setCTA2Enabled(true)} ><i className='icon icon-add mr-2'></i>Add another</button>}
                            { isCTA2Enabled && <button className='btn btn-outline' onClick ={() => deleteCta2()} ><i className='icon icon-delete mr-2'></i>Delete another</button>}
                        </div>
                    </div>
                    <div className='panel panel-bordered mb-3'>
                        <div className='panel-header m-1 d-flex'>
                            <h6 className='mb-0 medium mr-3'>Audience</h6>
                        </div>
                        <div className='panel-body'>
                            <div className='form-group'>
                                <label className='form-label text-dark medium'>Website's *</label>
                                { !showWebsiteSelection && 
                                    <StyledSelect
                                        styles={{
                                            ...styles,
                                            menu: (provided) => ({
                                                ...provided,
                                                minWidth: '100%',
                                                width: 'fit-content',
                                                maxWidth:'100%',
                                                zIndex:100000,
                                                }),
                                        }}
                                        width={'100%'}
                                        isMulti
                                        isClearable={selectedWebsites.some((v) => !v.isFixed)}
                                        onChange={handleChange}
                                        value={selectedWebsites}
                                        options={websiteOptions} 
                                    />
                                }
                                <div className='form-group d-flex' style={{padding: '0.875rem 0'}}>
                                    <h6 className='mb-0 medium mr-3'>Select All Websites</h6>
                                    <label className='toggle-control toggle-control-sm mb-2'>
                                        <input type='checkbox' checked={showWebsiteSelection} onChange={() => onSelectAllWebsite()} />
                                        <span className='control'></span>
                                    </label>
                                </div>
                                
                                <span >
                                    Select a website to target your campaign. You can select multiple websites from your added websites.<a href='/websites-setup#' className='primary-link' onClick={() => history.push('/websites-setup')} >Click here to manage websites.</a>
                                </span>
                                { !canSendToGPM() && <div className='error-message'>
                                    Please be aware that not all selected websites have been migrated to Chirpyweb.com platform. To send notifications to old subscribers on Get Push Monkey, only choose the migrated websites for this campaign. For other websites, consider creating a new campaign.
                                </div>}
                            </div>
                            <hr/>
                            <div className='form-group'>
                                    <label className='form-label text-dark medium'>Segments</label>
                                    <StyledSelect
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                minWidth: '18rem',
                                                maxWidth:'18rem',
                                                zIndex:100000,
                                                }),
                                        }}
                                        onChange={onChangeSegments}
                                        value={selectedSegments}
                                        options={segments} 
                                    />
                                    <span >
                                        Leave empty to send to all subscribers. If a segment is selected, only the subscribers that fall within the selected segment will receive the notification.<a href='/segments#' className='primary-link' onClick={() => history.push('/segments')} >Click here to manage segments.</a>
                                    </span>
                                </div>
                                <hr/>
                                <div className='form-group' >
                                    <label className='form-label text-dark medium'>Topics</label>
                                    {/* <select className='form-control custom-select-md'>
                                        <option>All Subscribers</option>
                                        <option></option>
                                        <option></option>                                                    
                                    </select>  */}
                                    <div style={{width: '18rem'}}  className='form-group  date-form-group mb-0'>
                                        <div     
                                            className='input-addon input-group-right' 
                                            onClick={() => setIsFilterOpen(!isFilterOpen)} 
                                        >
                                            <i className='icon icon-chevron-down icon-down'></i>
                                            <input
                                                value={valueString}
                                                className='form-control'
                                                readOnly
                                                style={{textTransform: 'capitalize'}}
                                            />
                                            
                                        </div>
                                        {
                                                isFilterOpen && <MultiValueDropdown
                                                    setIsFilterOpen={setIsFilterOpen}
                                                    checkBoxData={topics}
                                                    filterValue={selectedTopics}
                                                    changeValue={onChangeTopics}
                                                />
                                        }
                                    </div>
                                    {/* <StyledSelect
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                minWidth: '18rem',
                                                maxWidth:'18rem',
                                                zIndex:100000,
                                                }),
                                        }}
                                        isMulti
                                        onChange={onChangeTopics}
                                        value={selectedTopics}
                                        options={topics} /> */}
                                    <span >
                                        Only the subscribers that fall under the selected topics will receive the notification. <a href='/topics#' className='primary-link' onClick={() => history.push('/topics')} >Click here to manage topics.</a>
                                    </span>
                                </div>
                                <hr/>
                            <div className='form-group ol-12 col-md-6 col-x4 pd-0'>
                                <label className='form-label text-dark medium'>Tag</label>
                                {/* <select className='form-control custom-select-md'>
                                    <option>All Subscribers</option>
                                    <option></option>
                                    <option></option>                                                    
                                </select>  */}
                                <input 
                                    type='text' 
                                    className='form-control'
                                    value={tag}
                                    onChange={({target}) => setTag(target.value)} 
                                    maxLength={20}
                                />  
                                
                            </div>
                            <div className='form-group'>
                                <span>
                                    Add custom Tags to your notifications. These Tags are for internal reference only and not seen by your readers. Tags can be seen in the exported reports.
                                </span>
                            </div>
                            {
                                canSendToGPM() && <>
                                <hr/>
                                <div className='form-group'>
                                    <label className='form-label text-dark medium'>Send to GPM Subscribers</label>
                                    <label className='toggle-control toggle-control-sm mb-3 ml-2'>
                                        <input 
                                            type='checkbox' 
                                            checked={gpmSubscriber}
                                            onChange={() => setGpmSubscriber(!gpmSubscriber)}    
                                        />
                                        <span className='control'></span>
                                    </label>
                                    <p>Notification will be sent to old Subscribers from Get Push Monkey along with current ChirpyWeb subscriber.</p>
                                </div>
                            </>
                            }
                            <hr/>
                            <div className='form-group'>
                                <label className='form-label text-dark medium'>Test Devices</label>
                                <label className='toggle-control toggle-control-sm mb-3 ml-2'>
                                    <input 
                                        type='checkbox' 
                                        checked={enableForTestDevice}
                                        onChange={() => setEnableForTestDevice(!enableForTestDevice)}    
                                    />
                                    <span className='control'></span>
                                </label>
                                <p>Notification will only be sent to Test Devices. <a href='/subscribers' className='primary-link' onClick={() => history.push('/subscribers')}>Click here to manage Test Devices</a></p>
                            </div>                                            
                        </div>
                    </div>
                    <div className='panel panel-bordered'>
                        <div className='panel-header m-1 d-flex'>
                            <h6 className='mb-0 medium mr-3'>Timing</h6>
                        </div>
                        <div className='panel-body'>
                            <div className='d-flex justify-content-between align-items-center mb-1'>
                                <div className='custom-control custom-radio'>
                                    <input 
                                        type='radio' 
                                        id='sendImmediately' 
                                        name='sendImmediately' 
                                        className='custom-control-input' 
                                        checked={schedulingType === 'IMMED'}
                                        onChange={() => changeSchedulingType('IMMED')}
                                    />
                                    <label className='custom-control-label' htmlFor='sendImmediately'>Send Immediately</label>
                                </div>
                            </div>
                            <div className={!isFeatureAvailable('schedule-campaign-as-per-timezone') 
                                    ? 'd-flex align-items-center mb-1'
                                    : 'd-flex justify-content-center align-items-center mb-1'
                                    }>
                                <div 
                                    className={!isFeatureAvailable('schedule-campaign-as-per-timezone') 
                                    ? 'custom-control custom-radio'
                                    : 'custom-control custom-radio full-width'
                                    }
                                style={{color: !isFeatureAvailable('schedule-campaign-as-per-timezone')
                                         ? '#647482'
                                         : 'black' }}>
                                    <input 
                                        type='radio' 
                                        id='schedule' 
                                        name='schedule' 
                                        className='custom-control-input' 
                                        checked={schedulingType === 'SCHED'}
                                        onChange={() => changeSchedulingType('SCHED')}
                                        disabled={!isFeatureAvailable('schedule-campaign-as-per-timezone')}
                                    />
                                    <label className='custom-control-label' htmlFor='schedule'>Schedule As Per Timezone</label>
                                    {
                                        schedulingType === 'SCHED' && <div className='form-row align-items-center'>
                                            <div className='form-group col-sm-6 col-lg-4'>
                                                <label className='form-label text-dark medium'>Date *</label>
                                                <input 
                                                    type='date' 
                                                    className='form-control full-width' 
                                                    min={getMinDate()}
                                                    value={schedulingDate}
                                                    onChange={({target}) => changeDate(target.value)}
                                                />
                                            </div>
                                            <div className='form-group col-sm-6 col-lg-4'>
                                                <label className='form-label text-dark medium'>Time *</label>
                                                <input 
                                                    type='time' 
                                                    className='form-control full-width' 
                                                    min={getMinTime()}    
                                                    value={schedulingTime}
                                                    onChange={({target}) => changeTime(target.value)}
                                                />
                                            </div>
                                            <div className='form-group col-sm-6 col-lg-4'>
                                                <label className='form-label text-dark medium'>Timezone *</label>
                                                <div className='custom-select'>
                                                <StyledSelect
                                                    menuPlacement='top'
                                                    styles={{
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            minWidth: '100%',
                                                            maxWidth:'100%',
                                                            zIndex: 100000000000,
                                                        }),
                                                    }}
                                                    width={'100%'}
                                                    onChange={changeTimeZone}
                                                    value={getTimeZone()}
                                                    options={getTimeZones()} />
                                                    {/* <select value={timezone} onChange={({target}) => changeTimeZone(target.value)} className='form-control'>
                                                        {
                                                            timezones.map(({name, tzCode}, index) => <option value={tzCode} key={index} >{name}</option>)
                                                        }
                                                        <option>(GMT + 00:00) UTC</option>
                                                        <option>Woocommerce</option>
                                                        <option>Shopify</option>
                                                        <option>Wordpress</option>
                                                    </select> */}
                                                </div>
                                            </div>
                                            { schedulingTimeError && <div><span className='error-message'>{schedulingTimeError}</span></div>}
                                        </div>
                                    }
                                </div>
                                {!isFeatureAvailable('schedule-campaign-as-per-timezone') && <PremiumLock /> }                                               
                            </div>
                            <div className={!isFeatureAvailable('schedule-campaign-as-per-subscriber-timezone') 
                                    ? 'd-flex align-items-center mb-1'
                                    : 'd-flex justify-content-center align-items-center mb-1'
                                    }>
                                <div className={!isFeatureAvailable('schedule-campaign-as-per-subscriber-timezone') 
                                        ? 'custom-control custom-radio'
                                        : 'custom-control custom-radio full-width'
                                        }
                                    style={{color: !isFeatureAvailable('schedule-campaign-as-per-subscriber-timezone')
                                    ? '#647482'
                                    : 'black' }}
                                >
                                    <input 
                                        type='radio' 
                                        id='timeZone' 
                                        name='timeZone' 
                                        className='custom-control-input' 
                                        checked={schedulingType === 'BYSTZ'}
                                        onChange={() => changeSchedulingType('BYSTZ')}
                                        disabled={!isFeatureAvailable('schedule-campaign-as-per-subscriber-timezone')}
                                    />
                                    <label className='custom-control-label' htmlFor='timeZone'>Schedule As Per Subscriber's Timezone</label>
                                    {
                                            schedulingType === 'BYSTZ' && <div className='form-row align-items-center'>
                                                <div className='form-group col-sm-6 col-lg-4'>
                                                    <label className='form-label text-dark medium'>Date *</label>
                                                    <input 
                                                        type='date' 
                                                        className='form-control full-width' 
                                                        min={getMinDate()}
                                                        value={schedulingDate}
                                                        onChange={({target}) => changeDate(target.value)}
                                                    />
                                                </div>
                                                <div className='form-group col-sm-6 col-lg-4'>
                                                    <label className='form-label text-dark medium'>Time *</label>
                                                    <input 
                                                        type='time' 
                                                        className='form-control full-width' 
                                                        min={getMinTime()}  
                                                        value={schedulingTime}  
                                                        onChange={({target}) => changeTime(target.value)}
                                                    />
                                                </div>
                                                { schedulingTimeError && <div><span className='error-message'>{schedulingTimeError}</span></div>}
                                            </div>
                                        }
                                </div>
                                {!isFeatureAvailable('schedule-campaign-as-per-subscriber-timezone') && <PremiumLock /> }   
                            </div>
                        </div>
                    </div>
                </div>

                <NotificationPreview
                    title={title}
                    message={message}
                    banner={banner !== null ? bannerPath: ''}
                    icon={icon !== null ? iconPath : ''}
                    is_cta_enabled = {is_cta_enabled}
                    isCTA2Enabled = {(is_cta_enabled && isCTA2Enabled)}
                    button={cta1Title}
                    addl_button={ cta2Title}
                />
            </div>
        </div>
        </div>

        { openCropper && <IconCropper
                    open={openCropper} 
                    onClose={onCancelIconCrop} 
                    url={iconPath} 
                    onSave={getCroppedIcon} 
                />
        }

        { openBannerCropper && <IconCropper
                        open={openBannerCropper} 
                        onClose={onCancelBannerCrop} 
                        url={bannerPath} 
                        onSave={getCroppedBanner}
                        aspect={2/1}
                    />
        }

    </>
};


export default CreateCampaigns;